import React, { useState, useEffect } from 'react'
import edit_icon from "../../assets/images/edit_icon.png"
import profile_pic from "../../assets/images/logo.png";
import pass_key from "../../assets/images/pass_key.png"
import address_icon from "../../assets/images/address_icon.png"
import edit from "../../assets/images/edit.png"
import msg_icon from "../../assets/images/msg_icon.png"
import './style.css'
import { UserModal } from '../../components/Generic/userModals/UserModal'
import NotificationsTab from './NotificationsTab'
import { CustomSweetAlert, PhotoUploadModal } from '../../components/Generic';
import MyComments from './MyComments'
import { withFirebase } from '../../services'
import { FileUploadWithURL } from '../../common';
import UserAppointmentsPopup from "./UserAppointmentsPopup";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const UserProfile = (props) => {
    const [showUserAppointmentsPopup, setShowUserAppointmentsPopup] = useState(false);
    const [showVideoLink, setShowVideoLink] = useState(false);
    const { firebase } = props;
    const [isSaving, setIsSaving] = useState(false)
    const reload = () => window.location.reload();
    const [currentTab, setCurrentTab] = useState("your comments")
    const [modalShow, setModalShow] = useState(false)
    const [modalName, setModalName] = useState("")
    const [profilePhoto, setProfilePhoto] = useState(null)
    const [userData, setUserData] = useState(null)
    const [isProvider, setIsProvider] = useState(false)

    const [SweetAlert, setSweetAlert] = useState({
        show: false,
        type: "info",
        title: "",
        onConfirm: () => { setSweetAlert({ ...setSweetAlert, show: false }) },
        onCancel: () => { setSweetAlert({ ...setSweetAlert, show: false }) }
    });

    const assessmentQuestions = {
    GAD2: [
        {
            id: "1",
            text: "Feeling nervous, anxious, or on edge"
        },
        {
            id: "2",
            text: "Not being able to stop or control worrying"
        }
    ],

    GAD7: [
        {
            id: "Q1",
            text: "Feeling nervous, anxious, or on edge"
        },
        {
            id: "Q2",
            text: "Not being able to stop or control worrying"
        },
        {
            id: "Q3",
            text: "Worrying too much about different things"
        },
        {
            id: "Q4",
            text: "Trouble relaxing"
        },
        {
            id: "Q5",
            text: "Being so restless that it is hard to sit still"
        },
        {
            id: "Q6",
            text: "Becoming easily annoyed or irritable"
        },
        {
            id: "Q7",
            text: "Feeling afraid as if something awful might happen"
        }
    ],

    PHQ2: [
        {
            id: "1",
            text: "Little interest or pleasure in doing things"
        },
        {
            id: "2",
            text: "Feeling down, depressed, or hopeless"
        }
    ],

    PHQ9: [
        {
            id: "1",
            text: "Little interest or pleasure in doing things"
        },
        {
            id: "2",
            text: "Feeling down, depressed, or hopeless"
        },
        {
            id: "3",
            text: "Trouble falling or staying asleep, or sleeping too much"
        },
        {
            id: "4",
            text: "Feeling tired or having little energy"
        },
        {
            id: "5",
            text: "Poor appetite or overeating"
        },
        {
            id: "6",
            text: "Feeling bad about yourself — or that you are a failure or have let yourself or your family down"
        },
        {
            id: "7",
            text: "Trouble concentrating on things, such as reading the newspaper or watching television"
        },
        {
            id: "8",
            text: "Moving or speaking so slowly that other people could have noticed. Or the opposite—being so fidgety or restless that you have been moving around a lot more than usual"
        },
        {
            id: "9",
            text: "Thoughts that you would be better off dead or of hurting yourself in some way"
        }
    ]
};

const answerOptions = {
    0: "Not at all",
    1: "Several days",
    2: "More than half the days",
    3: "Nearly every day"
};

    const isConsentAdmin =
    firebase.auth.currentUser &&
    (
        firebase.auth.currentUser.email === "nathcorpdev@gmail.com" ||
        firebase.auth.currentUser.email === "lecresha@envuehealth.com"
    );

    const [PhotoModal, setPhotoModal] = useState(false)

    useEffect(() => {
        getUsersData()
    }, [])

    const email = "cyberquantumservices@gmail.com";
    const subject = "Delete account request";

    const getUsersData = async () => {
    const uid = firebase.auth.currentUser.uid;
    const userEmail = firebase.auth.currentUser.email;

    // 1️⃣ First check healthCareProfessionals
    const snap = await firebase.db
        .collection("healthCareProfessionals")
        .where("email", "==", userEmail)
        .where("isRequestPending", "==", false)
        .limit(1)
        .get();

    if (!snap.empty) {
        // ✅ Provider found
        const providerDoc = snap.docs[0];
        const data = providerDoc.data();

        // Make same object structure as users table
        const providerUserObject = {
            ...data,
            email: data.email || userEmail,
            name: data.name || "",
            profilePhoto: data.profilePhoto || data.headshotURL || null,
            location:
                typeof data.location === "string"
                    ? data.location
                    : data.location?.address ||
                      data.address ||
                      "N/A"
        };

        if (providerUserObject.profilePhoto) {
            setProfilePhoto(providerUserObject.profilePhoto);
        }

        setUserData(providerUserObject);

        // Subscription check
        if (
            data.subscription &&
            (data.subscription === "core" ||
             data.subscription === "premium")
        ) {
            setShowVideoLink(true);
        } else {
            setShowVideoLink(false);
        }

        setIsProvider(true)

    } else {
        
        setIsProvider(false)
        // 2️⃣ If no provider found, check users table
        const userRef = firebase.db.collection("users").doc(uid);

        userRef.onSnapshot((doc) => {
            if (doc.exists) {
                const data = doc.data();

                if (data?.profilePhoto) {
                    setProfilePhoto(data.profilePhoto);
                }

                setUserData(data);
                setShowVideoLink(false);
            } else {
                console.log("No user found");
            }
        });
    }
};

async function downloadAllMentalHealthAssesment() {
    try {
        const snapshot = await firebase.db
        .collection("mentalHealthResponses")
        .get();

        // ---------------------------------------------------------
        // Assessment questions
        // ---------------------------------------------------------
        const assessmentQuestions = {
            GAD2: [
                {
                    id: "1",
                    text: "Feeling nervous, anxious, or on edge"
                },
                {
                    id: "2",
                    text: "Not being able to stop or control worrying"
                }
            ],

            GAD7: [
                {
                    id: "Q1",
                    text: "Feeling nervous, anxious, or on edge"
                },
                {
                    id: "Q2",
                    text: "Not being able to stop or control worrying"
                },
                {
                    id: "Q3",
                    text: "Worrying too much about different things"
                },
                {
                    id: "Q4",
                    text: "Trouble relaxing"
                },
                {
                    id: "Q5",
                    text: "Being so restless that it is hard to sit still"
                },
                {
                    id: "Q6",
                    text: "Becoming easily annoyed or irritable"
                },
                {
                    id: "Q7",
                    text: "Feeling afraid as if something awful might happen"
                }
            ],

            PHQ2: [
                {
                    id: "1",
                    text: "Little interest or pleasure in doing things"
                },
                {
                    id: "2",
                    text: "Feeling down, depressed, or hopeless"
                }
            ],

            PHQ9: [
                {
                    id: "1",
                    text: "Little interest or pleasure in doing things"
                },
                {
                    id: "2",
                    text: "Feeling down, depressed, or hopeless"
                },
                {
                    id: "3",
                    text: "Trouble falling or staying asleep, or sleeping too much"
                },
                {
                    id: "4",
                    text: "Feeling tired or having little energy"
                },
                {
                    id: "5",
                    text: "Poor appetite or overeating"
                },
                {
                    id: "6",
                    text: "Feeling bad about yourself — or that you are a failure or have let yourself or your family down"
                },
                {
                    id: "7",
                    text: "Trouble concentrating on things, such as reading the newspaper or watching television"
                },
                {
                    id: "8",
                    text: "Moving or speaking so slowly that other people could have noticed. Or the opposite—being so fidgety or restless that you have been moving around a lot more than usual"
                },
                {
                    id: "9",
                    text: "Thoughts that you would be better off dead or of hurting yourself in some way"
                }
            ]
        };

        // ---------------------------------------------------------
        // Answer values
        // ---------------------------------------------------------
        const answerOptions = {
            0: "Not at all",
            1: "Several days",
            2: "More than half the days",
            3: "Nearly every day"
        };

        // ---------------------------------------------------------
        // All possible question headers
        // ---------------------------------------------------------
        const allQuestions = [];

        Object.values(assessmentQuestions).forEach(questions => {
            questions.forEach(question => {
                if (!allQuestions.includes(question.text)) {
                    allQuestions.push(question.text);
                }
            });
        });

        // ---------------------------------------------------------
        // Convert Firebase documents into Excel rows
        // ---------------------------------------------------------
        const excelData = [];

        snapshot.forEach(doc => {
            const response = doc.data();

            const assessmentId = response.assessmentId || "";

            const questions =
                assessmentQuestions[assessmentId] || [];

            const answers = response.answers || {};

            // Basic information
            const row = {
                "Email": response.email || "",
                "Assessment": assessmentId,
                "Score": response.score ?? "",
                "Submitted Date": ""
            };

            // -----------------------------------------------------
            // Handle Firestore Timestamp
            // -----------------------------------------------------
            if (response.submittedDate) {

                if (
                    typeof response.submittedDate.toDate === "function"
                ) {
                    row["Submitted Date"] =
                        response.submittedDate.toDate()
                            .toLocaleString("en-IN");
                }

                else if (response.submittedDate.seconds) {
                    row["Submitted Date"] =
                        new Date(
                            response.submittedDate.seconds * 1000
                        ).toLocaleString("en-IN");
                }

                else {
                    row["Submitted Date"] =
                        response.submittedDate;
                }
            }

            // -----------------------------------------------------
            // Add every question as a column
            // -----------------------------------------------------
            allQuestions.forEach(questionText => {
                row[questionText] = "";
            });

            // -----------------------------------------------------
            // Fill answers for this assessment
            // -----------------------------------------------------
            questions.forEach(question => {

                let answerValue = answers[question.id];

                // Also check numeric key
                if (answerValue === undefined) {
                    answerValue = answers[Number(question.id)];
                }

                if (
                    answerValue !== undefined &&
                    answerValue !== null
                ) {
                    row[question.text] =
                        answerOptions[answerValue] ??
                        answerValue;
                }
            });

            excelData.push(row);
        });

        // ---------------------------------------------------------
        // Create worksheet
        // ---------------------------------------------------------
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // ---------------------------------------------------------
        // Improve column widths
        // ---------------------------------------------------------
        const columnWidths = [
            {
                wch: 30
            },
            {
                wch: 15
            },
            {
                wch: 10
            },
            {
                wch: 25
            },
            ...allQuestions.map(() => ({
                wch: 45
            }))
        ];

        worksheet["!cols"] = columnWidths;

        // ---------------------------------------------------------
        // Create workbook
        // ---------------------------------------------------------
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Mental Health Responses"
        );

        // ---------------------------------------------------------
        // Generate Excel file
        // ---------------------------------------------------------
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        // ---------------------------------------------------------
        // Download
        // ---------------------------------------------------------
        const blob = new Blob(
            [excelBuffer],
            {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
        );

        saveAs(
            blob,
            `MentalHealthResponses_${new Date()
                .toISOString()
                .slice(0, 10)}.xlsx`
        );

        console.log(
            `Successfully exported ${excelData.length} responses.`
        );

    } catch (error) {

        console.error(
            "Error downloading mental health assessments:",
            error
        );

        alert(
            "Failed to download mental health assessment data. Please check the console."
        );
    }
}

const downloadConsentDetails = async () => {

    const snapshot = await firebase.db
        .collection("consentDetailsHealthierPath")
        .orderBy("createdDate", "desc")
        .get();

    const data = snapshot.docs.map(doc => {
        const x = doc.data();

        return {
            ChildName: x.childName || "",
            ParentName: x.parentName || "",
            Email: x.email || "",
            Phone: x.phone || "",
            EmergencyContact: x.emergencyContactName || "",
            EmergencyPhone: x.emergencyContactPhone || "",
            ConsentAccepted: x.consentAccepted ? "Yes" : "No",
            ConsentDate: x.consentDate || "",
            MediaConsent: x.mediaConsent || "",
            MedicalConsiderations: x.medicalConsiderations || "",
            Signature: x.signature || "",
            Program: x.programName || "",
            PoweredBy: x.poweredBy || "",
            SubmittedFrom: x.submittedFrom || "",
            FormVersion: x.formVersion || "",
            ConsentId: x.consentId || "",
            CreatedDate: x.createdDate?.toDate
                ? x.createdDate.toDate().toLocaleString()
                : "",
            ConsentAcceptedDate: x.consentAcceptedDate?.toDate
                ? x.consentAcceptedDate.toDate().toLocaleString()
                : ""
        };
    });

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Consent Details");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const excelData = data.map(response => {

    const assessmentId = response.assessmentId;

    const questions = assessmentQuestions[assessmentId] || [];

    const answers = response.answers || {};

    const row = {
        "Email": response.email || "",
        "Assessment": assessmentId || "",
        "Score": response.score ?? "",
        "Submitted Date": response.submittedDate
            ? new Date(
                response.submittedDate.seconds * 1000
            ).toLocaleString("en-IN")
            : ""
    };

    questions.forEach(question => {

        // Try both string and numeric question IDs
        let answerValue = answers[question.id];

        if (answerValue === undefined) {
            answerValue = answers[String(question.id)];
        }

        if (answerValue !== undefined && answerValue !== null) {
            row[question.text] =
                answerOptions[answerValue] ?? answerValue;
        } else {
            row[question.text] = "";
        }
    });

    return row;
});

    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, `ConsentDetails_${new Date().toISOString().slice(0,10)}.xlsx`);
};

const cancelSubscriptionPackage = async () => {
  try {
    const currentUser = firebase.auth().currentUser;

    if (!currentUser) {
      throw new Error("User is not logged in.");
    }

    const userEmail = currentUser.email;

    // 1️⃣ Find healthcare professional
    const snap = await firebase.db
      .collection("healthCareProfessionals")
      .where("email", "==", userEmail)
      .where("isRequestPending", "==", false)
      .limit(1)
      .get();

    if (snap.empty) {
      throw new Error("Healthcare professional record not found.");
    }

    // 2️⃣ Get the document
    const doc = snap.docs[0];
    const data = doc.data();

    console.log("Healthcare Professional:", data);

    // 3️⃣ Get Stripe subscription ID
    const subscriptionId = data.subscriptionId;

    if (!subscriptionId) {
      throw new Error("No Stripe subscription ID found for this user.");
    }

    console.log("Stripe Subscription ID:", subscriptionId);

    // 4️⃣ Call your Cloud Run / Cloud Function
    const response = await fetch(
      "https://cancelstripesubscription-611486537983.us-east5.run.app",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subscriptionId: subscriptionId,
        }),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || "Cancellation failed");
    }

    console.log("Cancelled:", result);

    alert("Subscription cancelled successfully");

  } catch (error) {
    console.error("Cancel subscription error:", error);
    alert(error.message);
  }
};

    const changeTab = (name) => {
        setCurrentTab(name)
    }

    const handleProfileChange = (e) => {
        setProfilePhoto(e.currentTarget.files[0])
        setPhotoModal(true);
    }

    const updateUserProfile = async (url) => {
        debugger;
    const userId = firebase.auth.currentUser.uid;
    const userEmail = firebase.auth.currentUser.email;

    try {
        let dataTobeSaved = { ...userData };
        dataTobeSaved.profilePhoto = url;

        // 1️⃣ Check if provider exists
        
        
        if (isProvider) {
            const snap = await firebase.db
            .collection("healthCareProfessionals")
            .where("email", "==", userEmail)
            .where("isRequestPending", "==", false)
            .limit(1)
            .get();
            const providerDoc = snap.docs[0];
            const existingData = providerDoc.data();

            // ✅ Update healthcareProfessional fields correctly
            const providerUpdateObject = {
                ...existingData,

                email: dataTobeSaved.email || userEmail,
                name: dataTobeSaved.name || "",
                profilePhoto: url,
                headshotURL: url, // keep both if app uses both

                location:
                    typeof dataTobeSaved.location === "string"
                        ? dataTobeSaved.location
                        : existingData.location,

                address:
                    typeof dataTobeSaved.location === "string"
                        ? dataTobeSaved.location
                        : existingData.address
            };

            await firebase.db
                .collection("healthCareProfessionals")
                .doc(providerDoc.id)
                .set(providerUpdateObject, { merge: true });

        } else {
            // ✅ Normal user update
            await firebase.db
                .collection("users")
                .doc(userId)
                .set(dataTobeSaved, { merge: true });
        }

        setSweetAlert({
            ...SweetAlert,
            show: true,
            title: "Profile Successfully Updated.",
            type: "success",
            onConfirm: () => {
                setSweetAlert({ ...SweetAlert, show: false });
                setModalShow(false);
            }
        });

    } catch (error) {
        console.log(error);
        setIsSaving(false);
    }
};

    const PhotoToSave = (dataUrl) => {
        let Data = FileUploadWithURL({ img: dataUrl, path: `profileImage`, firebase: firebase, name: userData.name });
        Data.then(url => {
            updateUserProfile(url)
            setProfilePhoto(dataUrl)
            setIsSaving(false)
            setPhotoModal(false);
        }).catch(e => {
            setPhotoModal(false);
            setIsSaving(false)
        })
    }

    const onPasswordReset = async () => {
        await firebase.auth.sendPasswordResetEmail(userData.email).then(function () {
            setSweetAlert({
                show: true,
                type: "success",
                message: "A reset password link has been sent to your email",
                onConfirm: () => { setSweetAlert({ ...setSweetAlert, show: false }) },
                onCancel: () => { setSweetAlert({ ...setSweetAlert, show: false }) }
            })
        }).catch(function (error) {
            console.log(error);
            setSweetAlert({
                show: true,
                type: "warning",
                message: error.message,
                onConfirm: () => { setSweetAlert({ ...setSweetAlert, show: false }) },
                onCancel: () => { setSweetAlert({ ...setSweetAlert, show: false }) }
            })
        });
    }

    return (
        <section>
            <div className="profile-container">
                <div className="header-data">
                    <div className="mid-data">
                        <div className="profile">
                            <img src={profilePhoto ? profilePhoto : profile_pic} alt="User" />
                            <div className="change-profile">
                                <button className="btn">+</button>
                                <input type="file" accept='image/*' onChange={(e) => handleProfileChange(e)} />
                            </div>
                        </div>

                        <div className="profile-right">
                            <div className="name-container" style={{ display: "inline-flex" }}>
                                <span>{userData?.name}</span>
                                <img onClick={() => {
                                    setModalName("username")
                                    setModalShow(true)
                                }} src={edit_icon} alt="edit-name" />
                            </div>

                            <div className="email">
                                <div className="back-shade"><img src={msg_icon} alt="msg" /></div>
                                <p className="mail-id">{userData?.email}</p>
                            </div>

                            <span onClick={() => {
                                setModalName("email")
                                setModalShow(true)
                            }} className="change-mail">Change details</span>

                            <div>
                                <a title='To delete account mail to cyberquantumservices@gmail.com with your account id'
                                   className="change-mail"
                                   href={`mailto:${email}?subject=${encodeURIComponent(subject)}`}>
                                    Delete Account
                                </a>
                            </div>
                            

                           <table><tr>
                            <td><button
                                onClick={() => setShowUserAppointmentsPopup(true)}
                                style={{ background: "none", border: "none", color: "#ffffff", cursor: "pointer", textDecoration: "underline", marginTop: "10px", fontSize: "13px" }}>
                                View My Appointments
                            </button></td><td>{isConsentAdmin && (
    <>
    <table><tr><td><button
            onClick={downloadConsentDetails}
            style={{
                marginLeft: "10px",
                background: "none",
                border: "none",
                color: "#ffffff",
                cursor: "pointer",
                textDecoration: "underline",
                marginTop: "10px",
                fontSize: "13px"
            }}
        >
            Download Consent Details
        </button></td><td><button
            onClick={downloadAllMentalHealthAssesment}
            style={{
                marginLeft: "10px",
                background: "none",
                border: "none",
                color: "#ffffff",
                cursor: "pointer",
                textDecoration: "underline",
                marginTop: "10px",
                fontSize: "13px"
            }}
        >
            Download Mental Health Assesment
        </button></td><td>
            {isProvider && (
                                        <><button
            onClick={cancelSubscriptionPackage}
            style={{
                marginLeft: "10px",
                background: "none",
                border: "none",
                color: "#ffffff",
                cursor: "pointer",
                textDecoration: "underline",
                marginTop: "10px",
                fontSize: "13px"
            }}
        >
            Cancel Subscription Package
        </button></>)}</td></tr></table>
        
    </>
)}</td></tr></table> 

                            {showVideoLink && (
                                <a style={{ color: "#ffffff", textDecoration: "underline", cursor: "pointer", marginTop: "10px" }} target="_blank"
  rel="noopener noreferrer" href='https://apps.apple.com/us/app/envue-health/id1533563884'>
                                    To record a video bio please install the ios app
                                </a>
                            )}
                        </div>

                        <div className="right-data">
                            <div className="address">
                                <div className="location">
                                    <div className="back-shade"><img src={address_icon} alt="location" style={{ width : "20px" }}/></div>
                                    <span>{userData?.location ? userData?.location : "N/A"}</span>
                                </div>
                                </div>
                                <div className="address">
                                <div className="location">
                                    <div className="back-shade"><img src={edit} alt="location"  style={{ width : "20px" }}/></div>
                                    <span onClick={() => {
                                    setModalName("location")
                                    setModalShow(true)
                                }} className="change-location">Change location</span>
                                    </div>
                            </div>
<div className="address">
                            <div className="password">
                                <div className="back-shade"><img src={pass_key} alt="pass" style={{ width : "20px" }}/></div>
                                <span onClick={onPasswordReset}>Change password</span>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="profile-list-inner">
                <div className="container">
                    <div className="tabs-container">
                        <span onClick={() => changeTab("your comments")} className={currentTab === "your comments" ? 'active' : "span"}>Your Comments</span>
                        <span onClick={() => changeTab("notifications")} className={currentTab === "notifications" ? 'active' : "span"}>Notifications</span>
                    </div>
                    {currentTab === "your comments" ? <MyComments /> : <NotificationsTab userData={userData} />}
                </div>
            </div>

            <UserModal show={modalShow} setModalShow={setModalShow} name={modalName} userData={userData} SweetAlert={SweetAlert} setSweetAlert={setSweetAlert} reload={reload} onHide={reload} />
            <CustomSweetAlert {...SweetAlert} />
            <PhotoUploadModal show={PhotoModal} onHide={() => setPhotoModal(false)} img={profilePhoto} onSave={PhotoToSave} isSaving={isSaving} setIsSaving={setIsSaving} />

            {showUserAppointmentsPopup && (
                <UserAppointmentsPopup firebase={firebase} onClose={() => setShowUserAppointmentsPopup(false)} />
            )}
        </section>
    )
}

export default withFirebase(UserProfile)